import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTopRef() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // use "smooth" if you prefer
    });
  }, [pathname]);

  return null;
}
